import { ThunkDispatch } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { AnyAction } from 'redux'

type TypedDispatch<T> = ThunkDispatch<T, unknown, AnyAction>

export type TAppDispatch = TypedDispatch<any>

export const useAppDispatch = () => useDispatch<TAppDispatch>()
